// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1O2Wl","modalForm":"UpgradeEpcsModal_modalForm__3dthx","modalFooter":"UpgradeEpcsModal_modalFooter__1YH3r"};